export const RESET_STATE = 'RESET_STATE';

export const reset = () => ({
  type: RESET_STATE
});
